<ul class="breadcrumb ms-4 ps-0">
  <li class="breadcrumb-item"><a routerLink="" class="roboto-medium">Home</a></li>
  <li class="breadcrumb-item"><a routerLink="" class="roboto-medium">Planning</a></li>
  <li class="breadcrumb-item"><a routerLink="" class="roboto-medium">Group I</a></li>
  <li *ngFor="let breadcrumb of breadcrumbs; let i = index;" class="breadcrumb-item">
    <a [routerLink]="[breadcrumb.url]" *ngIf="breadcrumbs.length==(i+1)"
      class="current roboto-medium">{{breadcrumb.label}}</a>
    <a [routerLink]="[breadcrumb.url]" *ngIf="breadcrumbs.length!=(i+1)"
      class="prev roboto-medium">{{breadcrumb.label}}</a>
  </li>
</ul>